module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-15.18b968d8.png";